var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "#8E8E8E",
    strokeWidth: 2,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M8 10a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m6 0a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0v-3a1 1 0 1 0-2 0v3a1 1 0 1 1-2 0v-5a1 1 0 0 1 1.708-.705A3 3 0 0 1 14 10M8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};
export default SvgLinkedIn;